module.exports = __webpack_public_path__ + "img/82200.8ce7ad2d.jpg";